import React, { useState } from "react";
import { Icon } from "..";
import Styles from "./CourseSearch.module.css";

const CourseSearch = ({ courses, setFilteredCourses }) => {
	const [query, setQuery] = useState("");
	const [isActive, setIsActive] = useState(false);

	const handleFocus = () => setIsActive(true);
	const handleBlur = () => setIsActive(false);

	const handleSearch = (e) => {
		const searchTerm = e.target.value.toLowerCase();
		setQuery(searchTerm);

		if (searchTerm.length > 0) {
			const results = courses.filter(
				(course) =>
					course.data.card_title.toLowerCase().includes(searchTerm) ||
					course.data.card_description.toLowerCase().includes(searchTerm)
			);
			setFilteredCourses(results);
		} else {
			setFilteredCourses(courses);
		}
	};

	const handleClear = () => {
		setQuery("");
		setFilteredCourses(courses);
	};

	return (
		<div>
			<div className='formRow'>
				<div className={Styles.search}>
					<label
						htmlFor='search'
						className={Styles.label}
						data-active={isActive || query ? "true" : "false"}>
						<Icon
							icon='Search'
							color='var(--dark-grey)'
						/>
						Search courses
					</label>
					<input
						className={Styles.input}
						id='search'
						type='text'
						value={query}
						onChange={handleSearch}
						onFocus={handleFocus}
						onBlur={handleBlur}
					/>
					<div
						className={Styles.clearContainer}
						onClick={handleClear}>
						<Icon
							icon='Close'
							color='var(--dark-grey)'
							className={Styles.clear}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CourseSearch;
